import { PrimaryPageTemplate } from "@/components/templates/primary-page-template"
import { EvaluationDashboard } from "@/components/evaluation-dashboard"

/**
 * `/dashboard` — Course Evaluations landing page for Surveys & Evaluations.
 *
 * Implements the term kanban (current / last), evaluation state cards (cases 1–9),
 * and past-term analytics table per the product dashboard spec.
 */
export default function DashboardPage() {
  return (
    <PrimaryPageTemplate siteHeader={{ title: "Dashboard" }}>
      <EvaluationDashboard />
    </PrimaryPageTemplate>
  )
}
